module.exports = __webpack_public_path__ + "dfa25e470b69d81428be54242b6c9bd1.svg";